// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

export { default } from '../[tourId]/leaderboard';
